import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const AppAnalyticsChart = ({ analyticsData }) => {
	const data = {
		labels: ['Positive', 'Neutral', 'Constructive', 'Questions', 'Negative'],
		datasets: [
			{
				label: 'App Reviews Analytics',
				data: [
					analyticsData?.positive || 0,
					analyticsData?.neutral || 0,
					analyticsData?.constructive || 0,
					analyticsData?.questions || 0,
					analyticsData?.negative || 0,
				],
				backgroundColor: [
					'#00C49F',
					'#90EE90',
					'#FFBB28',
					'#FF8042',
					'#FF4560',
				],
				hoverOffset: 4,
			},
		],
	};

	return (
		<div>
			<h3>AI Categorized Analytics</h3>
			<Doughnut data={data} />
		</div>
	);
};

export default AppAnalyticsChart;
